import { Box, GlobalStyles } from '@mui/material';
import {
  Splide,
  SplideSlide,
  Splide as SplideInstance,
} from '@splidejs/react-splide';
import type { Splide as SplideClass } from '@splidejs/splide';
import { useRef, useEffect } from 'react';

import '@splidejs/react-splide/css';
import { useDeviceType } from '@app/hooks/useBrowserHooks';

interface SlideProductImageProps {
  images: Array<string>;
}

export const SlideProductImage = ({ images }: SlideProductImageProps) => {
  const mainRef = useRef<SplideInstance>(null);
  const thumbsRef = useRef<SplideInstance>(null);
  const { isDesktop } = useDeviceType();

  useEffect(() => {
    if (mainRef.current && thumbsRef.current && thumbsRef.current.splide) {
      mainRef.current.sync(thumbsRef.current.splide as SplideClass);
    }
  }, []);

  return (
    <Box width="100%" mx="auto">
      <GlobalStyles
        styles={{
          '.splide__arrow': {
            fontSize: '20px',
            height: isDesktop ? '40px' : '30px',
            width: isDesktop ? '40px' : '30px',
          },
          '.splide__arrow--next': {
            marginRight: isDesktop ? '-10px' : '-5px',
          },
          '.splide__arrow--next::before': {
            marginRight: '-5px',
            position: 'static',
          },
          '.splide__arrow--prev': {
            marginLeft: isDesktop ? '-10px' : '-5px',
          },
          '.splide__arrow--prev::before': {
            marginLeft: '-5px',
            position: 'static',
          },
        }}
      />
      {images.length > 0 && (
        <Box mt={3}>
          <Splide
            options={{
              arrows: true,
              autoplay: true,
              cover: true,
              fixedHeight: 220,
              fixedWidth: 360,
              focus: 'center',
              gap: '10px',
              interval: 2000,
              isNavigation: true,
              pagination: false,
              rewind: true,
              type: 'loop',
            }}
            ref={thumbsRef}
            aria-label="Thumbnails"
          >
            {images.map((src, i) => (
              <SplideSlide key={i}>
                <Box
                  height="auto"
                  position="relative"
                  width="auto"
                  sx={{
                    '&:hover .hoverOverlay': {
                      opacity: 0.3,
                    },
                  }}
                >
                  <Box
                    className="hoverOverlay"
                    sx={{
                      bgcolor: 'white',
                      height: '100%',
                      left: 0,
                      opacity: 0,
                      position: 'absolute',
                      top: 0,
                      transition: 'opacity 0.3s ease-in-out',
                      width: '100%',
                      zIndex: 1,
                    }}
                  />
                  <Box
                    component="img"
                    src={src}
                    alt={`Thumbnail ${i + 1}`}
                    sx={{
                      height: '100%',
                      objectFit: 'cover',
                      width: '100%',
                    }}
                  />
                </Box>
              </SplideSlide>
            ))}
          </Splide>
        </Box>
      )}
    </Box>
  );
};
